import './App.css';

function App(){
    return(
        <div className="why">

            <div className="left bg2" >
                <h2>What Do I bring?</h2>
                <p>A strong desire to learn new things.</p>
                <p>A deep understanding of how things work.</p>
                <p>The dedication to solve major problems.</p>

            </div>

            <div className="center bg3">
                <h2>What do I bring to Software?</h2>
                <p>An eye for small details.</p>
                <p>A flexable effiective team member.</p>
                <p>a good sense of humor.</p>
            </div>

            <div className="right bg" >
                <h2>What value do I add to a team?</h2>
                <p>Passion for innovation.</p>
                <p>A dedication for the highest standards.</p>
                <p>The desire to make a huge impact.</p>

            </div>
        </div>
    )
}
export default App;
